const ths = [
  {
    id: 1,
    label: 'ID',
    intlKey: 'table.id',
    sortable: false,
    sortableId: 'id'
  },
  {
    id: 2,
    label: 'First name',
    intlKey: 'table.first_name',
    sortable: false,
    sortableId: 'person.first_name'
  },
  {
    id: 3,
    label: 'Last name',
    intlKey: 'table.last_name',
    sortable: false
  },
  {
    id: 4,
    label: 'Email',
    intlKey: 'table.email',
    sortable: false
  },
  {
    id: 7,
    label: 'Action',
    intlKey: 'table.action',
    sortable: false,
    right: true
  }
]

export default ths
